import joinReducer from "./joinReducer";
import gameDashboardCardCreateReducer from "./game_dashboard_card_create_reducer";
import { combineReducers } from "redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as ActionType from "../actionTypes/type";

// Redux: Root Reducer
const appReducer = combineReducers({
  joinReducer: joinReducer,
  gameDashboardCardCreateReducer: gameDashboardCardCreateReducer
});

const RootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === ActionType.GAME_EXIT_REQUEST) {
    console.log("Track-Result-10")
    AsyncStorage.removeItem("persist:root");
    AsyncStorage.clear();
    state = undefined;
  }
  return appReducer(state, action);
};

// Exports
export default RootReducer;
